'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedSize = require('I18n/components/FormattedSize');

var _FormattedSize2 = _interopRequireDefault(_FormattedSize);

var _UIFileAttachment = require('UIComponents/attachment/UIFileAttachment');

var _UIFileAttachment2 = _interopRequireDefault(_UIFileAttachment);

var _UINanoProgress = require('UIComponents/progress/UINanoProgress');

var _UINanoProgress2 = _interopRequireDefault(_UINanoProgress);

var _fileIsImage = require('conversations-lib/attachments/fileIsImage');

var _fileUploadGetters = require('conversations-internal-schema/file-upload/operators/fileUploadGetters');

var _uploadedBytes = require('conversations-internal-schema/file-upload/operators/uploadedBytes');

var _getFileName = require('conversations-internal-schema/file-upload/operators/getFileName');

var _getFileSize = require('conversations-internal-schema/file-upload/operators/getFileSize');

var _isUploadCompleted = require('conversations-internal-schema/file-upload/operators/isUploadCompleted');

var _ImageAttachmentPreview = require('./ImageAttachmentPreview');

var _ImageAttachmentPreview2 = _interopRequireDefault(_ImageAttachmentPreview);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileUpload = function (_React$Component) {
  _inherits(FileUpload, _React$Component);

  function FileUpload() {
    _classCallCheck(this, FileUpload);

    return _possibleConstructorReturn(this, (FileUpload.__proto__ || Object.getPrototypeOf(FileUpload)).apply(this, arguments));
  }

  _createClass(FileUpload, [{
    key: 'customFilePreview',
    value: function customFilePreview() {
      var attachment = this.props.attachment;
      var file = (0, _fileUploadGetters.getFile)(attachment);

      if (!(0, _fileIsImage.fileIsImage)(file)) {
        return undefined;
      }

      return _react2.default.createElement(_ImageAttachmentPreview2.default, { imageFile: file });
    }
  }, {
    key: 'fileInfo',
    value: function fileInfo() {
      if ((0, _isUploadCompleted.isUploadCompleted)(this.props.attachment)) {
        return _react2.default.createElement(_FormattedSize2.default, { value: (0, _getFileSize.getFileSize)(this.props.attachment) });
      }

      return _react2.default.createElement(_FormattedMessage2.default, {
        message: 'cvInternalComponentsAttachments.stagedAttachment.uploadProgress',
        options: {
          uploadedBytes: _I18n2.default.formatSize((0, _uploadedBytes.uploadedBytes)(this.props.attachment), {
            precision: 2,
            strip_insignificant_zeroes: true
          }),
          totalBytes: _I18n2.default.formatSize((0, _getFileSize.getFileSize)(this.props.attachment))
        }
      });
    }
  }, {
    key: 'attachmentUse',
    value: function attachmentUse() {
      if ((0, _isUploadCompleted.isUploadCompleted)(this.props.attachment)) {
        return 'default';
      }

      return 'processing';
    }
  }, {
    key: 'renderProgress',
    value: function renderProgress() {
      if ((0, _isUploadCompleted.isUploadCompleted)(this.props.attachment)) {
        return null;
      }

      return _react2.default.createElement(_UINanoProgress2.default, {
        boxShadow: false,
        value: (0, _fileUploadGetters.getUploadProgress)(this.props.attachment)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _UIFileAttachment2.default,
        {
          closeable: true,
          onCloseClick: this.props.onRemove,
          use: this.attachmentUse(),
          fileName: (0, _getFileName.getFileName)(this.props.attachment),
          fileInfo: this.fileInfo(),
          renderPreview: this.customFilePreview(),
          style: { minWidth: 220 }
        },
        this.renderProgress()
      );
    }
  }]);

  return FileUpload;
}(_react2.default.Component);

FileUpload.propTypes = {
  attachment: (0, _RecordPropType2.default)('FileUploadRecord').isRequired,
  onRemove: _react.PropTypes.func.isRequired
};

exports.default = FileUpload;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/attachments/FileUpload.js
// module id = 1158
// module chunks = 2 3